import React from 'react';
import '../style/About.css';
import { FaArrowRight, FaArrowLeft, FaMapMarkedAlt, FaShoppingCart, FaCheckCircle, FaStar, FaPlay } from 'react-icons/fa';

import { Container } from 'react-bootstrap';
import image1 from '../img/Eritrea.jpg';
import image2 from '../img/download (20).jpg';
import image3 from '../img/Toyota Car Hire Namibia _ Advanced Car Hire.jpg';
import image4 from '../img/download (21).jpg';
import leftImage from '../img/—Pngtree—golden floating wavy shapes vector_3723932.png';  // Add your left corner image
import vanTourImage from '../img/car15.jpg';
import vanaImage from '../img/photo_5855177513200895958_y.jpg'; // Adjust the path as needed
const About = () => {
  return (
    <div>
      {/* Left corner image */}
      <div className="left-corner-image" style={{ position: 'relative', top: '0px', bottom: '-500px', textAlign: 'left' }}>
  <img src={leftImage} alt="Left Corner" style={{ marginTop: '10px', marginBottom: '-1500px', verticalAlign: 'middle' }} />
</div>


      <section className="hero-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>About Us</h1>
            </div>
          </div>
        </div>
      </section>
      <section className="py-5">
        <div className="container">
          <div className="row gx-4 align-items-center justify-content-between">
            <div className="col-md-5 order-2 order-md-1">
              <div className="mt-5 mt-md-0">
                <span className="text-muted">Our Story</span>
                <h2 className="display-5 fw-bold">About Vana Tour and Travel</h2>
                <p className="lead">
                  Vana Tour and Travel is an Ethiopian company that provides
                  top-notch tour services and car rentals. We offer customized
                  tours that showcase the beauty and rich culture of Ethiopia,
                  while also offering reliable and comfortable car rentals for your
                  convenience.
                </p>
                <p className="lead">
                  Whether you’re exploring the historical sites, enjoying the
                  natural wonders, or need a car to take you around, we’re here to
                  provide you with the best service possible.
                </p>
              </div>
            </div>
            <div className="col-md-6 offset-md-1 order-1 order-md-2">
              <div className="row gx-2 gx-lg-3">
                {/* Images with bigger size */}
                <div className="col-6">
                  <div className="mb-2">
                    <img className="img-fluid rounded-3 larger-img" src={image1} alt="Tour 1" />
                  </div>
                </div>
                <div className="col-6">
                  <div className="mb-2">
                    <img className="img-fluid rounded-3 larger-img" src={image2} alt="Tour 2" />
                  </div>
                </div>
                <div className="col-6">
                  <div className="mb-2">
                    <img className="img-fluid rounded-3 larger-img" src={image3} alt="Tour 3" />
                  </div>
                </div>
                <div className="col-6">
                  <div className="mb-2">
                    <img className="img-fluid rounded-3 larger-img" src={image4} alt="Tour 4" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="how-it-works py-5">
        <Container>
          <div className="row text-center">
            <div className="col-12 mb-4">
              <span className="custom-badge text-white mb-3 d-inline-block">How It Works</span>
              <h2 className="display-5 fw-bold mb-3">Book Your Tour with Vana Tour & Car Rental</h2>
              <p className="text-muted">It's easy! Just follow these simple steps to plan your trip.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="service-card text-center">
                <div className="icon-wrapper mb-3">
                  <FaMapMarkedAlt size={32} color="white" />
                </div>
                <h4 className="service-title mb-3">Visit Our Site</h4>
                <p className="service-text">Explore our range of destinations and tours available throughout Ethiopia.</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="service-card text-center">
                <div className="icon-wrapper mb-3">
                  <FaShoppingCart size={32} color="white" />
                </div>
                <h4 className="service-title mb-3">Choose Your Tour</h4>
                <p className="service-text">Select the destination and tour that best suits your preferences and travel style.</p>
              </div>
            </div>
            <div className="col-md-4 mb-4">
              <div className="service-card text-center">
                <div className="icon-wrapper mb-3">
                  <FaCheckCircle size={32} color="white" />
                </div>
                <h4 className="service-title mb-3">Book Your Trip</h4>
                <p className="service-text">Easily book your tour and let us handle the rest for a seamless experience.</p>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <section className="van-tour-hero-section">
            {/* Background Shapes */}
            <div className="van-tour-hero-shape van-tour-shape-1"></div>
            <div className="van-tour-hero-shape van-tour-shape-2"></div>

            <div className="container">
                <div className="row align-items-center">
                    {/* Hero Content */}
                    <div className="col-lg-6 van-tour-hero-content">
                        <h1 className="van-tour-hero-title">Explore the World with Our Van Tours & Car Rentals</h1>
                        <p className="van-tour-hero-subtitle">Book your next adventure today! Choose from our premium fleet of vans and cars for a comfortable journey.</p>

                        {/* CTA Buttons */}
                        <div className="van-tour-hero-buttons">
                            <a href="#" className="van-tour-btn van-tour-btn-primary me-3 mb-2">Book Now</a>
                            <a href="#" className="van-tour-btn van-tour-btn-outline mb-2">Watch Demo <FaPlay className="ms-2" /></a>
                        </div>

                        {/* Stats */}
                        <div className="van-tour-hero-stats row">
                            <div className="col-4">
                                <div className="van-tour-stat-item">
                                    <div className="van-tour-stat-number">5K+</div>
                                    <div className="van-tour-stat-label">Happy Customers</div>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="van-tour-stat-item">
                                    <div className="van-tour-stat-number">4.8/5</div>
                                    <div className="van-tour-stat-label">Customer Rating</div>
                                </div>
                            </div>
                            <div className="col-4">
                                <div className="van-tour-stat-item">
                                    <div className="van-tour-stat-number">24/7</div>
                                    <div className="van-tour-stat-label">Customer Support</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Hero Image */}
                    <div className="col-lg-6 van-tour-hero-image">
   <img src={vanTourImage} alt="Van Tour and Car Rental" className="van-tour-hero-image-main" />

                        {/* Floating Cards */}
                        <div className="van-tour-floating-card van-tour-card-1">
                            <div className="d-flex align-items-center">
                                <FaCheckCircle className="text-success me-2" />
                                <span>100+ Successful Tours</span>
                            </div>
                        </div>

                        <div className="van-tour-floating-card van-tour-card-2">
                            <div className="d-flex align-items-center">
                                <FaStar className="text-warning me-2" />
                                <span>5.0 Rating</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="py-5" style={{ backgroundColor: '#f4f4f4' }}>
      <div className="container">
        <div className="row justify-content-center text-center mb-3">
          <div className="col-lg-8 col-xl-7">
            <span className="text-muted">Our Services</span>
            <h2 className="display-5 fw-bold" style={{ color: '#0056b3' }}>Vana Tour & Car Rental</h2>
            <p className="lead" style={{ color: '#f7c700' }}>
              Discover the best travel experiences with Vana Tours and hassle-free car rentals. Explore the world in comfort and style!
            </p>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-4 order-2 order-md-1">
            <div className="text-center">
              <div className="text-muted">
                <svg className="bi bi-aspect-ratio" fill="currentColor" height="48" viewBox="0 0 16 16" width="48">
                  <path d="M0 3.5A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 12.5v-9zM1.5 3a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z"></path>
                  <path d="M2 4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H3v2.5a.5.5 0 0 1-1 0v-3zm12 7a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1H13V8.5a.5.5 0 0 1 1 0v3z"></path>
                </svg>
              </div>
              <h5 className="fw-bold mt-3" style={{ color: '#0056b3' }}>Responsive Booking</h5>
            </div>
            <div className="my-5 text-center">
              <div className="text-muted">
                <svg className="bi bi-emoji-wink" fill="currentColor" height="48" viewBox="0 0 16 16" width="48">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"></path>
                  <path d="M4.285 9.567a.5.5 0 0 1 .683.183A3.498 3.498 0 0 0 8 11.5a3.498 3.498 0 0 0 3.032-1.75.5.5 0 1 1 .866.5A4.498 4.498 0 0 1 8 12.5a4.498 4.498 0 0 1-3.898-2.25.5.5 0 0 1 .183-.683zM7 6.5C7 7.328 6.552 8 6 8s-1-.672-1-1.5S5.448 5 6 5s1 .672 1 1.5zm1.757-.437a.5.5 0 0 1 .68.194.934.934 0 0 0 .813.493c.339 0 .645-.19.813-.493a.5.5 0 1 1 .874.486A1.934 1.934 0 0 1 10.25 7.75c-.73 0-1.356-.412-1.687-1.007a.5.5 0 0 1 .194-.68z"></path>
                </svg>
              </div>
              <h5 className="fw-bold mt-3" style={{ color: '#f7c700' }}>Easy Booking Process</h5>
            </div>
            <div className="text-center">
              <div className="text-muted">
                <svg className="bi bi-layout-text-window-reverse" fill="currentColor" height="48" viewBox="0 0 16 16" width="48">
                  <path d="M13 6.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm0 3a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5z"></path>
                  <path d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12zM2 1a1 1 0 0 0-1 1v1h14V2a1 1 0 0 0-1-1H2zM1 4v10a1 1 0 0 0 1 1h2V4H1zm4 0v11h9a1 1 0 0 0 1-1V4H5z"></path>
                </svg>
              </div>
              <h5 className="fw-bold mt-3" style={{ color: '#0056b3' }}>Flexible Packages</h5>
            </div>
          </div>
          <div className="col-md-4 order-1 order-md-2">
            <div className="mb-4 mb-md-0">
              <img alt="Vana Tour and Car Rental" className="img-fluid rounded mx-auto" src={vanaImage} />
            </div>
          </div>
          <div className="col-md-4 order-3 order-md-3">
            <div className="text-center">
              <div className="text-muted">
                <svg className="bi bi-clipboard-check" fill="currentColor" height="48" viewBox="0 0 16 16" width="48">
                  <path d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z" fillRule="evenodd"></path>
                  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1V1.5z"></path>
                </svg>
              </div>
              <h5 className="fw-bold mt-3" style={{ color: '#f7c700' }}>Secure & Reliable</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  );
};

export default About;

